import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { BgRing } from "../Assets/img/DiamondRingBG.webp"
const DesignDiamondRing = () => {
  const settings = {
    customPaging: function (i) {
      return <a className="dots11">{i + 1}</a>;
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="RingBuilderHome design-diamond-ring-section">
      <Container fluid className="showcase-container h-100">
        <Row className="align-items-start  align-items-md-center mx-1440 h-100">
          <Col md={7} lg={"6"} xl={6} sm={12} className="px-0 order-2 order-md-1">
            <div className="textBox">
              <Heading className="text-start p-0">
                <span> Design Your Own </span>
                <h2>DIAMOND RING</h2>
                <p> Design a Diamond Ring That Reflects Your Style and Personality  </p>
                <div className="content">
                  <Link
                    to="/ringsettings"
                    className="btn btn-black"
                  >
                    START WITH A SETTING
                  </Link>
                  <Link to="/diamonds" className="btn btn-black-outline">
                    START WITH A DIAMOND{" "}
                  </Link>
                </div>
              </Heading>
            </div>
          </Col>
          <Col md={5} lg={"6"} xl={6} sm={12} className="w-100 h-50 order-1 order-md-2">
            {/* <div
              class="wistia_responsive_padding"
              style={{
                padding: "100% 0 0 0",
                position: "relative"
              }}
            >
              <div
                class="wistia_responsive_wrapper"
                style={{
                  height: "100%",
                  left: "0",
                  position: "absolute",
                  top: "0",
                  width: "100%",
                }}
              >

              </div>
            </div> */}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DesignDiamondRing;
